import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import {
    GstUserPanDataFetchUrl,
    GetAllUserInsuranceCertificateUrl,
    getAmountForMedicalInsuranceUrl,
    getBenefitsDataOfUserUrl,
    GetUserInsuranceCertificateUrl,
} from '../url';
import { toast } from 'react-toastify';

export const GstUserPanDataFetch = async (pan, checkExists = true) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserPanDataFetchUrl()}?pan_no=${pan}&check_exists=${checkExists}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getAmountForMedicalInsurance = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAmountForMedicalInsuranceUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getBenefitsDataOfUser = async (name) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getBenefitsDataOfUserUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetAllUserInsuranceCertificate = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetAllUserInsuranceCertificateUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetInsuranceCertificateAction = async (file_id, file_name) => {
  try {
    let token = await getToken();
    fetch(`${GetUserInsuranceCertificateUrl()}${file_id}`, {
      method: 'GET',
      ...getTokenHeader(token),
    }).then(function (t) {
      return t.blob().then((b) => {
        if (b.type.includes('application/json')) {
          return toast.error('No Certificate Found');
        }
        let a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', file_name);
        a.click();
      });
    });
  } catch (err) {
    console.log(err);
  }
};